import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || '';
    const sid = new URLSearchParams(hash.replace(/^#/, '')).get('session_id');
    if (!sid) {
      navigate('/', { replace: true });
      return;
    }
    fetch(`${API}/api/auth/session`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'X-Session-ID': sid },
      body: JSON.stringify({ session_id: sid }),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('auth failed'))))
      .then((u) => {
        setUser(u);
        window.history.replaceState(null, '', window.location.pathname);
        navigate(u?.role === 'admin' ? '/admin/leads' : '/account', { replace: true, state: { user: u } });
      })
      .catch(async () => {
        await refresh();
        navigate('/', { replace: true });
      });
  }, [navigate, setUser, refresh]);

  return (
    <div
      data-testid="auth-callback"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', color: '#143160' }}
    >
      <p style={{ fontFamily: 'Georgia, serif', fontSize: '1.25rem' }}>Signing you in…</p>
    </div>
  );
}
